import { cr, URLS } from "fire-wind-water";
import { $cmsData, settings } from "../common/setting";
import { scmsService } from "../services/site";
import * as $ from "jquery";
import { user } from "../user/index";
const paginationArt = require("../../art/common/tabPaginationNumber.art");
import { Email } from "../common/Email";
class Tab extends Email {
  $skelem = ".sk-cms-tab";
  $user: any = {};
  isLogin = false;
  activeIndex = 0;
  isPreview: boolean = settings.isPreview;
  isDesign: boolean = settings.isDesign;
  allTabData = {};
  total: number;
  current = 1;
  showCount: number;
  pageNum: number;
  pageIndexListCurrent = [];
  fileDetail = "";
  articleDetail = "";
  tid: string = settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null);
  sid: string = settings.siteId || URLS.getURL("sid") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].sid:null));
  cy: string = settings.category || URLS.getURL("cy") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].cy:null));
  t: string = settings.t || URLS.getURL("t") || (URLS.getURL("des")?null : (window['siteParams']? window['siteParams'].t:null));
  menuId: string = settings.menuId || URLS.getURL("menuId");
  currentFid = "";
  constructor() {
    super();
    $sk.template.module(this);
  }
  skAfterViewChecked(): void {
    if (this.isDesign) {
      $(".tab-main").css("overflow-x", "hidden");
    } else {
      $(".tab-main").css("overflow-x", "auto");
    }
    if (this.isPreview) {
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (
            d.type === "TAB" &&
            d.historyContent &&
            d.historyContent.content?.length
          ) {
            this.allTabData[d.id] = d.historyContent;
            this.total = settings.total || d.historyContent.content[0]?.total;
            this.current = settings.current || 1;
            this.showCount =
              settings.showCount || d.historyContent.content[0]?.showCount;
            this.initTabStyle(d.historyContent.style, d.id, 0);
            // this.initTabStyle(d.historyContent, d.id, 0);
            // this.initPaginationDom(d.id);
          }
        });
        cr.each(settings.page.items, (d) => {
          if (d.usePages === "fileinfo") {
            this.fileDetail = this.menuId
              ? `./fileInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${d.id}&cy=${this.cy}&t=${this.t}&menuId=${this.menuId}`
              : `./fileInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${d.id}&cy=${this.cy}&t=${this.t}`;
          }
          if (d.usePages === "articleinfo") {
            this.articleDetail = this.menuId
              ? `./articleInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${d.id}&cy=${this.cy}&t=${this.t}&menuId=${this.menuId}`
              : `./articleInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${d.id}&cy=${this.cy}&t=${this.t}`;
          }
        });
      });
    }
    // else {
    //   this.total = settings.total;
    //   this.current = settings.current;
    //   this.showCount = settings.showCount;
    // }
    this.initPaginationDom();
  }
  skUserEnd() {
    this.updateUser();
  }

  skUserChange() {
    this.updateUser();
  }

  updateUser() {
    const m = $sk.template.get();
    if (m.user.session) {
      this.isLogin = true;
      this.$user.session = m.user.session;
    } else {
      this.isLogin = false;
    }
  }
  changeTab(ev, tab, index, id, style) {
    // const tabData = this.allTabData[id];
    if (this.isDesign) {
      return;
    }
    this.activeIndex = index;
    this.current = 1;
    this.total = tab.total; // tabData.content[index].total;
    this.showCount = tab.showCount; // tabData.content[index].showCount;
    this.initTabStyle(style, id, index);
    this.initPaginationDom();
  }
  initTabStyle(style, id, index): void {
    // 设置tab未选中样式
    $(`#tab_${id} .tab`).css("background", "");
    $(`#tab_${id} .tab`).removeClass("activeTab big medium small");
    $(`#tab_${id} .tab`)
      .not(`#tab_${id} #tab_${id}_${index}`)
      .addClass(style.tabStyle.unselectedStyle.fontSize);
    const unselectedTab = $(`#tab_${id} .tab`);
    if (style.tabStyle.defaultBack.styleType != "default") {
      if (style.tabStyle.defaultBack.backgroundType == "color") {
        unselectedTab.css("background-color", style.tabStyle.defaultBack.color);
      }
      if (style.tabStyle.defaultBack.backgroundType == "img") {
        unselectedTab.css(
          "background",
          `url(${style.tabStyle.defaultBack.imgUrl})`
        );
      }
    } else {
      unselectedTab.css("background-color", "");
    }
    if (style.tabStyle.unselectedStyle.styleType != "default") {
      unselectedTab.css("color", style.tabStyle.unselectedStyle.color);
      unselectedTab.css("font-size", style.tabStyle.unselectedStyle.fontSize);
    } else {
      unselectedTab.css("color", "");
      unselectedTab.css("font-size", "");
    }
    // 设置tab选中样式
    const selectedTab = $(`#tab_${id} #tab_${id}_${index}`);
    $(`#tab_${id} #tab_${id}_${index}`).addClass("activeTab");
    if (style.tabStyle.selectedStyle.styleType != "default") {
      $(`#tab_${id} #tab_${id}_${index}`).addClass(
        style.tabStyle.selectedStyle.fontSize
      );
    }
    if (style.tabStyle.selectedBack.styleType != "default") {
      if (style.tabStyle.selectedBack.backgroundType == "color") {
        selectedTab.css("background", style.tabStyle.selectedBack.color);
      }
      if (style.tabStyle.selectedBack.backgroundType == "img") {
        selectedTab.css(
          "background",
          `url(${style.tabStyle.selectedBack.imgUrl})`
        );
      }
    } else {
      selectedTab.css("background", "");
    }
    if (style.tabStyle.selectedStyle.styleType != "default") {
      selectedTab.css("color", style.tabStyle.selectedStyle.color);
      // 添加CSS变量，让底部选中框颜色跟随字体颜色
      selectedTab.css("--tab-active-color", style.tabStyle.selectedStyle.color);
      // selectedTab.css(
      //   "font-size",
      //   tabData.style.tabStyle.selectedStyle.fontSize
      // );
    } else {
      selectedTab.css("color", "");
      selectedTab.css("font-size", "");
      selectedTab.css("--tab-active-color", "");
    }
    // 切换tab显示不同内容
    $(`#tab_${id} .tab-content`).css("display", "none");
    $(`#tabContent_${id}_${index}`).css("display", "block");
    $(`
        #tab_${id} #tabContent_${id}_${this.activeIndex} .file-wrap`).css(
      "display",
      "none"
    );
    $(`
      #tab_${id} #tabContent_${id}_${this.activeIndex} #page_${
      Number(this.current) - 1
    }_items`).css("display", "block");
  }
  initPaginationDom(id?): void {
    // const PaginationArr = document.querySelectorAll(`
    //   #tab_${id} .tab-pagination`);
    const PaginationArr = document.querySelectorAll(`.tab-pagination`);
    cr.each(PaginationArr, (dom) => {
      this.total = $(dom).data("total");
      this.showCount = $(dom).data("showcount");
      const total: number = Number(this.total) || 0;
      const current = Number(this.current);
      const pageSize = Number(this.showCount);
      this.pageNum = Math.ceil(total / pageSize);
      const pageIndexList = new Array(this.pageNum);
      for (let i = 0; i < pageIndexList.length; i++) {
        pageIndexList[i] = i + 1;
      }
      let pageIndexListCurrent = [];
      if (current < 4) {
        pageIndexListCurrent = pageIndexList.slice(0, 5);
      } else if (current >= 4 && current < this.pageNum - 2) {
        pageIndexListCurrent = pageIndexList.slice(current - 3, current + 2);
      } else {
        pageIndexListCurrent = pageIndexList.slice(-5);
      }
      this.pageIndexListCurrent = pageIndexListCurrent;
      // const pageStyle = this.allTabData[id].style.file.pagination;
      const pageStyle = $(dom).data("style");
      const params = {
        current: current,
        pageIndexListCurrent: pageIndexListCurrent,
        pageNum: this.pageNum,
        total: this.total,
        style: pageStyle, // pageStyle,
        // tabId: id,
        isPreview: this.isPreview,
      };
      dom.innerHTML = total > 0 ? paginationArt(params) : "";
    });
    this.skUpdateView();
  }
  tipsShow(e): void {
    const index = e.target.dataset.index;
    const tabId = $(e.target).parents(".tab-pagination").data("tabid");
    if (index == this.current) {
      return;
    }
    // 正式访问的链接改成了预览的链接，预览和正式要区分开
    if (this.isPreview && URLS.getURL("preview")) {
      $sk.alert("预览页面不支持跳转");
    } else {
      $(`
        #tab_${tabId} #tabContent_${tabId}_${this.activeIndex} .file-wrap`).css(
        "display",
        "none"
      );
      $(`
        #tab_${tabId} #tabContent_${tabId}_${this.activeIndex} #page_${
        Number(index) - 1
      }_items`).css("display", "block");
      // this.total = this.allTabData[tabId].content[this.activeIndex].total;
      // this.showCount =
      //   this.allTabData[tabId].content[this.activeIndex].showCount;
      this.total = $(e.target).parents(".tab-pagination").data("total");
      this.showCount = $(e.target).parents(".tab-pagination").data("showcount");

      this.current = index;
      this.initPaginationDom(tabId);
    }
  }
  nothing(): void {
    console.log("nothing");
  }
  goOuter(e, url, id, title): void {
    const info = {
      tenantId: settings.tenantId,
      siteId: settings.siteId,
      globalUserId: user.globalUserId,
      openId: user.openId || "",
      channel_code: settings.channel_code,
      memberId: user.memberId,
      sess: user.session,
      objTitle: title,
      objId: id,
      actionKey: "MIMAGETEXT",
    };
    scmsService.browse(info).subscribe((res) => {
      res;
    });
    window.open(url);
  }
  skUpdateView(): void {}
}
export { Tab };
